import { getStore } from '../store/store';
import { setItem, removeItem } from 'owa-local-storage';
import { CommandingViewMode } from 'owa-outlook-service-option-store/lib/store/schema/options/CommandingOptions';
import { isFeatureEnabled } from 'owa-feature-flags';

const BOOTSTRAP_RIBBON_IMPORT = 'bootstrapRibbonImport';

/**
 * Updates a localStorage entry indicating whether we should
 * begin importing the lazy ribbon import during bootstrap.
 * This value is effectively a hint that allows us to optimize
 * performance for known-ribbon users.
 */
export function updateBootstrapRibbonImportLocalStorage() {
    const viewMode = getStore().viewMode;
    const shouldImportDuringBootstrap =
        viewMode === CommandingViewMode.MultiLineRibbon ||
        viewMode === CommandingViewMode.SingleLineRibbon ||
        (viewMode === CommandingViewMode.CommandBar && isFeatureEnabled('mon-ribbon-toolbar'));

    if (shouldImportDuringBootstrap) {
        setItem(window, BOOTSTRAP_RIBBON_IMPORT, 'true');
    } else {
        removeItem(window, BOOTSTRAP_RIBBON_IMPORT);
    }
}
